/**
 * Кнопка панели инструментов: иконка-глиф с подсказкой и горячей клавишей.
 */
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

interface Props {
	icon: ReactNode;
	label: string;
	hotkey?: string;
	active?: boolean;
	disabled?: boolean;
	onClick: () => void;
}

export const ToolButton = ({ icon, label, hotkey, active, disabled, onClick }: Props) => (
	<Tooltip content={hotkey ? `${label} (${hotkey})` : label} side="bottom">
		<Button
			border={false}
			className={`flex size-8 items-center justify-center rounded-lg text-ink disabled:cursor-default disabled:opacity-40${
				active
					? " bg-accent-soft text-accent hover:bg-accent-soft"
					: " hover:bg-accent-soft hover:text-ink"
			}`}
			aria-label={label}
			disabled={disabled}
			onClick={onClick}
		>
			<Text as="span" className="size-5 [&>svg]:size-full">
				{icon}
			</Text>
		</Button>
	</Tooltip>
);
